import React,{useState, useEffect} from "react";
import './index.css'
import axios from 'axios';
import moment from "moment";
import { useLocation } from 'react-router-dom'
import { baseUrl,MLUrl} from "../../../constants";


const Reminder = ({vehicleData}) => {

    const pathname = useLocation().pathname.split("/");
    // console.log(JSON.stringify(vehicleData))

    const [VIN, setVIN] = useState();
    const [model, setModel] = useState([]);
    const [carDetails, setCarDetails] = useState([]);
    const [carNumber, setCarNumber] = useState("")
    const [vehicleId, setVehicleId] = useState([]);
    const [insurance, setInsurance] = useState([]);
    const [insuranceDate, setInsuranceDate] = useState("");
    const [carModel, setCarModel] = useState("");
    const [rul, setRUL] = useState(moment());

    const getJwtToken = () => { let token = localStorage.getItem("token") || undefined; return token === undefined ? "" : `${JSON.parse(token)}`; };

    const url = baseUrl+"/basicDetails/basic/";
    const user = {username: 'Jack'}

    useEffect(() => {
        // console.log(vehicleData)
        if(vehicleData.speed!==undefined) {
            
          setCarNumber(vehicleData.registeration_no)
          setCarModel(vehicleData.model_name)
        }
        
    })
   
    const url1 = baseUrl+"/get/vehicleData/"
    const url2 = MLUrl+'/predict';

    useEffect(()=>{


        var vinTemp =  pathname.at(4)
        const vin = {"vin":vinTemp};

        axios.post(url1, vin, {headers : {Authorization : `Bearer ${getJwtToken()}`}}).then((res) => {
            const distData = res.data.result
            var isu = distData["insurance_date"]
            setInsuranceDate(moment(isu).format('Do MMM YYYY'));
        })
       

        
        var bodyPredict = {"vin":vinTemp}
        axios.post(url2,bodyPredict).then((res) => {
            // var vinTemp =  pathname.at(4)
            // console.log(res.data)
            var rulArr = res.data;
            var rulResult = Math.floor(rulArr)
            var todayDate = moment();
            var rulDate = todayDate.add(rulResult, 'days'); 
            setRUL(rulDate);
               
            
            
            // Object.keys(res.data).map((item,index)=>{
            //     console.log(item)
            // })
           
            // console.log(rulDate.format('YYYY-MM-DD') + " luuuss " +todayDate.format('YYYY-MM-DD'))
        }).catch((err)=>{
            console.log("ML:",err)
        })

    },[vehicleData])



    return (
        <div className="reminders">
           <div className="reminder_head">Reminder</div>  
            <div className="reminder_main">
                
                <div className="reminder_tasks">
                    <div className="reminder_icon">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_2593_1208)">
                    <rect x="4" y="2" width="44" height="44" rx="22" fill="white" shape-rendering="crispEdges"/>
                    <path d="M32.488 33.1835L32.4196 33.3886L32.5725 33.5416L34.2256 35.1954C33.894 35.214 33.5601 35.18 33.2366 35.0935C32.7031 34.9509 32.2166 34.6703 31.8258 34.2801C31.0062 33.4603 30.7445 32.3013 31.0227 31.2486L31.0741 31.054L30.9318 30.9117L19.0877 19.0676L18.9453 18.9252L18.7507 18.9767C17.6988 19.2549 16.5399 18.994 15.7193 18.1736C15.3292 17.7829 15.0487 17.2963 14.9062 16.7628C14.8198 16.4393 14.786 16.1055 14.8047 15.7739L16.4578 17.4277L16.6108 17.5808L16.8161 17.5123L18.6727 16.8928L18.8386 16.8375L18.894 16.6715L19.5126 14.8167L19.581 14.6114L19.428 14.4584L17.7742 12.8046C18.1058 12.786 18.4396 12.82 18.7631 12.9065C19.2966 13.0491 19.7831 13.3296 20.1739 13.7199C20.9935 14.5396 21.2552 15.6986 20.977 16.7513L20.9256 16.9459L21.0679 17.0882L32.9121 28.9315L33.0544 29.0738L33.249 29.0224C34.3007 28.7442 35.4606 29.0058 36.2803 29.8254C36.6703 30.2163 36.9507 30.703 37.0933 31.2365C37.1798 31.5599 37.2138 31.8936 37.1953 32.2252L35.5409 30.5722L35.3879 30.4194L35.1828 30.4878L33.3279 31.1063L33.1619 31.1616L33.1066 31.3276L32.488 33.1835Z" fill="black" fill-opacity="0.43" stroke="black" stroke-width="0.7"/>
                    <path d="M23.7329 25.6506L17.519 31.8628L16.8995 31.2442L15.3535 33.4097L16.5907 34.646L18.7562 33.1L18.1376 32.4813L24.3515 26.2692L23.7329 25.6506Z" fill="black"/>
                    <path d="M25.8714 26.6032C26.2141 26.2605 26.2141 25.7086 25.8714 25.3659L24.634 24.1285C24.2913 23.7858 23.7394 23.7858 23.3966 24.1285C23.0539 24.4713 23.0539 25.0231 23.3966 25.3659L24.634 26.6032C24.9768 26.946 25.5286 26.946 25.8714 26.6032Z" fill="#FF6465"/>
                    <path d="M25.8713 26.6031L27.1087 25.3658L24.634 22.8911L23.3966 24.1284L25.8713 26.6031Z" fill="#FF6465"/>
                    <path d="M27.7273 25.9845L36.3888 17.323C36.7316 16.9802 36.7316 16.4283 36.3888 16.0856L33.9141 13.6109C33.5714 13.2681 33.0195 13.2681 32.6768 13.6109L24.0152 22.2724C23.6725 22.6151 23.6725 23.167 24.0152 23.5098L26.49 25.9845C26.8327 26.3272 27.3846 26.3272 27.7273 25.9845Z" fill="#FF6465"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M35.4606 15.1574L25.5615 25.0573L26.1801 25.676L36.0783 15.7759L35.4606 15.1574ZM34.2234 13.9202L24.3252 23.8194L24.9438 24.4379L34.842 14.5388L34.2234 13.9202Z" fill="#BC4C4D"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_2593_1208" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.575 0 0 0 0 0.563021 0 0 0 0 0.563021 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2593_1208"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2593_1208" result="shape"/>
                    </filter>
                    </defs>
                    </svg>


                    </div>
                    <div className="reminder_details">
                        <div className="reminder_date">
                        Next Maintenance 
                        </div>
                        <div className="task_descri">Needs next maintenance for </div>
                        <div className="task_descri">{carModel}</div>

                        <div className="task_status">expiry Date: {rul.format("Do MMM YYYY")}</div>
                    </div>
                </div>

                <div className="reminder_tasks">
                    <div className="reminder_icon">
                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_2593_1223)">
                    <rect x="4" y="2" width="44" height="44" rx="22" fill="white" shape-rendering="crispEdges"/>
                    <path d="M34.7166 24.4365L34.7166 24.4381C34.7237 26.594 34.1266 28.7088 32.9928 30.5425C31.859 32.3763 30.2341 33.8556 28.3023 34.8127L28.3006 34.8135L26.005 35.9614L23.7093 34.8135L23.7072 34.8125C21.7735 33.8569 20.1465 32.3782 19.011 30.5443C17.8755 28.7104 17.2771 26.5949 17.2836 24.438V24.4365V13.64L25.9929 11.8977L34.7166 13.6402L34.7166 24.4365ZM31.338 24.7048V21.32C31.338 20.995 31.209 20.6833 30.9792 20.4535C30.7494 20.2237 30.4377 20.0946 30.1127 20.0946H28.9203V18.9022C28.9203 18.5772 28.7912 18.2656 28.5614 18.0358C28.3316 17.806 28.0199 17.6769 27.695 17.6769H24.3101C23.9851 17.6769 23.6735 17.806 23.4437 18.0358C23.2139 18.2656 23.0848 18.5772 23.0848 18.9022V20.0946H21.8923C21.5674 20.0946 21.2557 20.2237 21.0259 20.4535C20.7961 20.6833 20.667 20.995 20.667 21.32V24.7048C20.667 25.0298 20.7961 25.3415 21.0259 25.5713C21.2557 25.8011 21.5674 25.9302 21.8923 25.9302H23.0848V27.1226C23.0848 27.4476 23.2139 27.7592 23.4437 27.989C23.6735 28.2188 23.9851 28.3479 24.3101 28.3479H27.695C28.0199 28.3479 28.3316 28.2188 28.5614 27.989C28.7912 27.7592 28.9203 27.4476 28.9203 27.1226V25.9302H30.1127C30.4377 25.9302 30.7494 25.8011 30.9792 25.5713C31.209 25.3415 31.338 25.0298 31.338 24.7048Z" fill="#93BA45" stroke="black"/>
                    <path d="M29.8709 21.552V24.463H27.4483V26.8856H24.5373V24.463H22.1147V21.552H24.5373V19.1294H27.4483V21.552H29.8709Z" fill="black"/>
                    <path d="M29.3106 16.104C31.6208 16.104 32.9389 17.4086 32.9389 19.7256V26.0718C32.9389 28.3752 31.6275 29.6933 29.3174 29.6933H22.9712C20.6542 29.6933 19.3496 28.3752 19.3496 26.0718V19.7256C19.3496 17.4086 20.6542 16.104 22.9712 16.104H29.3106ZM26.1375 19.8479C25.8249 19.8479 25.5735 20.0993 25.5735 20.4118V22.3279H23.6506C23.5011 22.3279 23.3585 22.3891 23.2497 22.491C23.1478 22.5997 23.0867 22.7417 23.0867 22.8919C23.0867 23.2044 23.3381 23.4558 23.6506 23.4626H25.5735V25.3855C25.5735 25.6981 25.8249 25.9495 26.1375 25.9495C26.45 25.9495 26.7014 25.6981 26.7014 25.3855V23.4626H28.6311C28.9437 23.4558 29.1951 23.2044 29.1951 22.8919C29.1951 22.5793 28.9437 22.3279 28.6311 22.3279H26.7014V20.4118C26.7014 20.0993 26.45 19.8479 26.1375 19.8479Z" fill="#8EB83F"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_2593_1223" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.575 0 0 0 0 0.563021 0 0 0 0 0.563021 0 0 0 0.2 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2593_1223"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2593_1223" result="shape"/>
                    </filter>
                    </defs>
                    </svg>



                    </div>
                    <div className="reminder_details">
                        <div className="reminder_date">
                        Insurance
                        </div>
                        <div className="task_descri">Vehicle {carNumber} insurance date</div>

                        <div className="task_status task_insurance">{insuranceDate}</div>
                    </div>
                </div>

                {/* <div className="reminder_tasks">
                    <div className="reminder_icon">
                        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_410_2451)">
                            <rect x="4" y="2" width="44" height="44" rx="22" fill="white" shape-rendering="crispEdges"/>
                            <path d="M34.09 26.9816L30.3233 23.2233C30.4021 22.8394 30.4412 22.4485 30.44 22.0566C30.4397 20.9822 30.1685 19.9251 29.6516 18.9832C29.1346 18.0413 28.3886 17.2449 27.4824 16.6676C26.5762 16.0903 25.5391 15.7508 24.4669 15.6804C23.3948 15.61 22.3222 15.8111 21.3483 16.265C21.2249 16.3213 21.1171 16.407 21.0344 16.5144C20.9516 16.6219 20.8963 16.7479 20.8733 16.8816C20.8504 17.0136 20.8596 17.1492 20.9002 17.2768C20.9409 17.4045 21.0117 17.5205 21.1066 17.615L24.7316 21.2316L23.2316 22.7316L19.615 19.1066C19.5197 19.0131 19.4033 18.9439 19.2757 18.9047C19.1481 18.8656 19.0129 18.8577 18.8816 18.8816C18.7488 18.9038 18.6233 18.9578 18.5159 19.0391C18.4085 19.1204 18.3224 19.2265 18.265 19.3483C17.8096 20.3254 17.6087 21.4018 17.681 22.4774C17.7534 23.5529 18.0966 24.5927 18.6787 25.5C19.2609 26.4073 20.063 27.1527 21.0106 27.6667C21.9581 28.1807 23.0203 28.4467 24.0983 28.44C24.4902 28.4412 24.8811 28.4021 25.265 28.3233L29.0233 32.09C29.1008 32.1681 29.1929 32.2301 29.2945 32.2724C29.396 32.3147 29.505 32.3365 29.615 32.3365C29.725 32.3365 29.8339 32.3147 29.9354 32.2724C30.037 32.2301 30.1292 32.1681 30.2066 32.09C30.2847 32.0125 30.3467 31.9203 30.389 31.8188C30.4313 31.7172 30.4531 31.6083 30.4531 31.4983C30.4531 31.3883 30.4313 31.2794 30.389 31.1778C30.3467 31.0763 30.2847 30.9841 30.2066 30.9066L26.1233 26.8233C26.0213 26.7219 25.8947 26.6487 25.756 26.6107C25.6173 26.5728 25.4711 26.5714 25.3316 26.6066C24.9293 26.7144 24.5148 26.7704 24.0983 26.7733C23.475 26.7788 22.8568 26.6609 22.2792 26.4264C21.7017 26.192 21.1763 25.8455 20.7332 25.4071C20.2901 24.9687 19.9382 24.447 19.6976 23.8719C19.4571 23.2969 19.3327 22.6799 19.3316 22.0566C19.3305 21.7775 19.3528 21.4987 19.3983 21.2233L22.665 24.4983C22.7424 24.5764 22.8346 24.6384 22.9361 24.6807C23.0377 24.723 23.1466 24.7448 23.2566 24.7448C23.3666 24.7448 23.4756 24.723 23.5771 24.6807C23.6787 24.6384 23.7708 24.5764 23.8483 24.4983L26.4983 21.8233C26.6485 21.6679 26.7325 21.4602 26.7325 21.2441C26.7325 21.028 26.6485 20.8204 26.4983 20.665L23.2566 17.3983C23.5321 17.3533 23.8108 17.331 24.09 17.3316C25.3417 17.3338 26.5413 17.8326 27.4257 18.7185C28.31 19.6044 28.8066 20.8049 28.8066 22.0566C28.8037 22.4732 28.7477 22.8876 28.64 23.29C28.6047 23.4294 28.6061 23.5756 28.6441 23.7143C28.682 23.853 28.7553 23.9796 28.8566 24.0816L32.94 28.165C33.0969 28.3219 33.3097 28.41 33.5316 28.41C33.7535 28.41 33.9664 28.3219 34.1233 28.165C34.2802 28.008 34.3684 27.7952 34.3684 27.5733C34.3684 27.3514 34.2802 27.1385 34.1233 26.9816H34.09Z" fill="black"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_410_2451" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="2"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0.575 0 0 0 0 0.563021 0 0 0 0 0.563021 0 0 0 0.2 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_410_2451"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_410_2451" result="shape"/>
                            </filter>
                            </defs>
                        </svg>


                    </div>
                    <div className="reminder_details">
                        <div className="reminder_date">
                            Monday, 6th April 2020
                        </div>
                        <div className="task_descri">Book for General Service</div>

                        <div className="task_status">COMPLETED</div>
                    </div>
                </div> */}


            </div> 
        </div>
    )
}

export default Reminder;
